import {View} from 'MWC';
import tpl from '../templates/Tariffs.jsx';
import BaseNewCardView from '../../../../pages/Cards/views/BaseNewCardView.js';
import {canUseDOM} from '../../../../helpers/canUseDOM.js';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            isMobile: canUseDOM ? window.innerWidth < 960 : false
        };
    }

    handleResize = () => {
        this.setState({isMobile: window.innerWidth < 960});
    };

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
}
